import gsap from 'gsap';

export type GSAPTimeline = gsap.core.Omit<gsap.core.Timeline, 'then'>;

const promiseTimeline = (
  target: gsap.TweenTarget | undefined,
  vars: gsap.TweenVars
): Promise<boolean> =>
  new Promise((resolve, reject) => {
    if (!target) return reject();

    gsap.killTweensOf(target);
    gsap.to(target, {
      ...vars,
      onComplete: () => resolve(true),
    });
  });

export default promiseTimeline;
